// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"572":"6261f912","971":"896f35d4"}[chunkId] + ".css";
};